import { Grid, Button, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import moment from "moment";
import DatePicker from "react-datetime";

import Loading from "../../loading";
import Snackbar from "../../snackbar";
import InputFormat from "../../../partials/inputForm";
import { styles } from "./style";
import LabelForm from "../../../partials/labelForm";
import TextForm from "../../../partials/textForm";
import { checkStringIsNumber, formatDatetime } from "../../../utils/setting";
// Component
class Discount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: {
        cardExpired: false,
        cardName: false,
        cardNumber: false,
        cardCVV: false,
      },
      serviceAccount: {},
    };
  }
  async componentDidMount() {
    this.props.onRef(this);
    const { t } = this.props;
    this.getServiceAccount();
  }
  getServiceAccount = async () => {
    let { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.getServiceAccount();
    this.loading.stopLoading();
    if (check.code !== 1) this.mSnackbar.handleClick(check.message, "error");
    // else if (check.code === 1 && check.data) this.setState({ serviceAccount: check.data }) // chỉ update những property của serviceAccount state được thay đổi khi gọi api updateServiceAccount
  };
  updateServiceAccount = async () => {
    let { t } = this.props;
    let { serviceAccount, isEdit } = this.state;
    if (isEdit.cardNumber && !checkStringIsNumber(serviceAccount.cardNumber))
      this.mSnackbar.handleClick(
        t("service_account_card_number_is_not_valid"),
        "warning"
      );
    else if (isEdit.cardCVV && !checkStringIsNumber(serviceAccount.cardCVV))
      this.mSnackbar.handleClick(
        t("service_account_card_cvv_is_not_valid"),
        "warning"
      );
    else {
      this.loading.startLoading();
      let check = await this.props.updateServiceAccount(serviceAccount);
      this.loading.stopLoading();
      this.setState({
        serviceAccount: {},
        isEdit: {
          cardNumber: false,
          cardName: false,
          cardCVV: false,
          cardExpired: false,
        },
      });
      if (check.code === 1) {
        this.mSnackbar.handleClick(
          t("service_account_update_service_account_successful")
        );
        this.getServiceAccount();
      } else if (check.error === 1183)
        this.mSnackbar.handleClick(
          t("service_account_please_fill_in_all_infomation"),
          "error"
        );
      else {
        this.mSnackbar.handleClick(
          check.message || check.error.message,
          "error"
        );
      }
    }
  };
  handleChangeValue = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let { serviceAccount, isEdit } = this.state;
    serviceAccount[name] = value;
    isEdit[name] = true;
    this.setState({ ...serviceAccount, ...isEdit });
  };
  handleChangeDate = (name, date) => {
    let milisecondInLocal =
      date && date._isAMomentObject ? date.valueOf() : moment().valueOf();
    let serviceAccount = this.state.serviceAccount;
    serviceAccount[name] = milisecondInLocal;
    this.setState(serviceAccount);
  };
  render() {
    const { classes, serviceAccount, t, serviceCode, i18n } = this.props;
    let {
      cardNumber,
      cardName,
      cardExpired,
      cardCVV,
      balance = 0,
      createdAt,
      updatedAt,
    } = this.state.serviceAccount;
    return (
      <div>
        <Paper className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <LabelForm label={t("service_account_serviceCode")} />
              <TextForm label={serviceCode} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LabelForm label={t("service_account_balance")} />
              <NumberFormat
                value={serviceAccount.balance}
                thousandSeparator
                displayType="text"
                renderText={(value) => <TextForm label={value} />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LabelForm label={t("service_account_createdAt")} />
              <TextForm label={formatDatetime(serviceAccount.createdAt)} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LabelForm label={t("service_account_updatedAt")} />
              <TextForm label={formatDatetime(serviceAccount.updatedAt)} />
            </Grid>
          </Grid>
        </Paper>
        <Paper className={classes.rootEdit}>
          <Loading onRef={(id) => (this.loading = id)} />
          <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
          <form className={classes.container} noValidate autoComplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  required
                  label={t("service_account_card_number")}
                  margin="normal"
                  value={cardNumber || serviceAccount.cardNumber}
                  name="cardNumber"
                  onChange={this.handleChangeValue}
                  placeholder={serviceAccount.cardNumber || "XXXX XXXX XXXX"}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  required
                  label={t("service_account_card_name")}
                  margin="normal"
                  value={cardName || serviceAccount.cardName}
                  name="cardName"
                  onChange={this.handleChangeValue}
                  placeholder={serviceAccount.cardName}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <DatePicker
                  renderInput={(props) => (
                    <InputFormat
                      required
                      InputProps={{
                        ...props,
                      }}
                      label={t("service_account_card_expired")}
                      margin="normal"
                      placeholder={serviceAccount.cardExpired || "XX/XXXX"}
                    />
                  )}
                  timeFormat="hh:mm A"
                  dateFormat="DD/MM/YYYY"
                  onChange={(date) =>
                    this.handleChangeDate("cardExpired", date)
                  }
                  value={cardExpired || serviceAccount.cardExpired}
                  locale={i18n.language === "vn" ? "vi" : "en"}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  required
                  label={t("service_account_card_cvv")}
                  margin="normal"
                  value={cardCVV || ""}
                  name="cardCVV"
                  onChange={this.handleChangeValue}
                  placeholder={this.props.serviceAccount.cardCVV || "XXXX"}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              style={{ marginTop: 16 }}
              justify="flex-end"
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.updateServiceAccount()}
                className={classes.button}
              >
                {t("service_account_save_infomation")}
              </Button>
            </Grid>
          </form>
        </Paper>
      </div>
    );
  }
}

Discount.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceAccount: state.serviceAccount.serviceAccount,
  serviceCode: state.user.user.roleId.serviceCode,
});

const mapDispatch = (dispatch) => ({
  getServiceAccount: dispatch.serviceAccount.getServiceAccount,
  updateServiceAccount: dispatch.serviceAccount.updateServiceAccount,
  addBalanceForOwner: dispatch.serviceAccount.addBalanceForOwner,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Discount)));
